/**
 * The two rubric documents, shared by Lesson Reports and Student Reports.
 *
 * `Proficiency.js`, `CollaborationTrend.js` and `ResourceHub.js` still carry
 * these documents as literals because each links a different anchor on them.
 */

export const MATH_RUBRIC_URL =
  "https://docs.google.com/document/d/1Ft503fy1Ui5ZDbZSDu8IsxxXqmVSSkjtrf_Ft4znzt4/edit?tab=t.0";

export const COLLAB_RUBRIC_URL =
  "https://docs.google.com/document/d/1eR3DQs4NWtr1I4wJ6UET3BdMIKTwYiaAzXnsE6Mqf2Y/edit?usp=sharing";

// The collaboration rubric opened at its levels section, for the Teamwork Level
// hover in the session report.
export const COLLAB_RUBRIC_LEVELS_URL =
  "https://docs.google.com/document/d/1eR3DQs4NWtr1I4wJ6UET3BdMIKTwYiaAzXnsE6Mqf2Y/edit?tab=t.0#heading=h.sa0q885n409p";
